import { combineReducers } from "redux"

import OneReducer from "./one"

export default combineReducers({ one: OneReducer })
